<red-header></red-header>
<red-page-content>
  <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
    <div class="tw:flex tw:min-h-full tw:w-full tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:px-4 tw:py-8">
      <h1 class="tw:block tw:text-xl">
        <ion-text color="primary" class="tw:font-bold">Registration</ion-text>
      </h1>
      <div class="tw:text-l tw:block tw:text-center">
        <ion-text color="primary" class="tw:font-bold">Why do we need your information?</ion-text>
      </div>
      <p class="md:tw:w-2/3 tw:w-full tw:text-center tw:text-xs">
        We require this information in order to access the profile and farm data used in this app, to personalize the
        reports and emails you send from this app and to allow you access to your saved data from other devices.
      </p>

      <div class="md:tw:w-2/3 tw:w-full">
        <ion-list [inset]="true" lines="full" class="no-last-line">
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="John"
              inputmode="text"
              [required]="true"
              type="text"
              formControlName="firstName"
              (ionInput)="onFirstNameInput($event)"
            >
              <div slot="label">First Name:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="Doe"
              inputmode="text"
              [required]="true"
              type="text"
              formControlName="lastName"
            >
              <div slot="label">Last Name:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="email@example.com"
              inputmode="email"
              [required]="true"
              type="email"
              formControlName="email"
            >
              <div slot="label">Email:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="email@example.com"
              inputmode="email"
              [required]="true"
              type="email"
              formControlName="confirmEmail"
            >
              <div slot="label">Confirm Email:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="DEMO INC."
              inputmode="text"
              [required]="true"
              type="text"
              formControlName="company"
            >
              <div slot="label">Company Name:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              redErrorMessage
              labelPlacement="stacked"
              placeholder="555-555-5555"
              inputmode="tel"
              [required]="true"
              type="text"
              formControlName="phone"
              [maskito]="phoneMask"
              [maskitoElement]="maskPredicate"
            >
              <div slot="label">Phone:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
        </ion-list>
      </div>
      <div class="md:tw:w-2/3 tw:w-full tw:px-4">
        <ion-button color="primary" expand="block" type="submit" [disabled]="registerForm.invalid">
          Next<ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </form>
</red-page-content>
